import './overview.scss';
import init_listing from 'components/listing/Listing';

function init() {
    init_listing('#career_listing_items', {
        query_all: 'careers/ajax_query_all',
        filters: [
            {
                el: '#listing_filter_location',
                type: 'dropdown',
                key: 'location',
                compare: '=',
            },
            // {
            //     el: '#listing_filter_type',
            //     type: 'dropdown',
            //     key: 'type',
            //     compare: '=',
            // },
        ],
        load_more: true,
        load_more_auto: true,
        transition_duration: 300,
        items_data: careers_data.items,
        post_count: parseInt(careers_data.post_count),
        found_posts: parseInt(careers_data.found_posts),
        query_args: careers_data.query_args,
    });
}

init();
